export const POST_TYPE_TO_SHOW = "POST_TYPE_TO_SHOW";
